<template>
  <div class="cont-xw">
    <div class="jg-head">产品应用</div>
    <img class="img-responsive center-block" src="../../common/images/RH06.jpg" />
    <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
          <div id="fast" class="jg-head">下载</div>
    <ul>
      <li class="form-group">
            <FileDownload href="/static/IVF-BU/IVF-RH06产品资料与手机兼容列表20171109.xls">兼容性excel表</FileDownload>
      </li>
      <li class="form-group">
            <FileDownload href="/static/SDK/RH06_SDK.rar">RH中性完整SDK下载</FileDownload>
      </li>

      <li class="form-group">
        <QRDownload></QRDownload>
      </li>
    </ul>
  </div>
</template>

<script>
import QRDownload from "@/base/qrdownload";
import FileDownload from '@/base/filedownload'
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
 
 methods: {

    riseup() {
        riseup()
      }

      
  },
  components: { QRDownload, FileDownload }
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/RH/06.vue